import React, { Component } from 'react';
import instance from "./axios-instance";
import SweetAlert from 'react-bootstrap-sweetalert';
import { toast } from 'react-toastify';
import jwt_decode from "jwt-decode";
import Systems from "./SystemFunction";
import MoblieMenu from "./mobilemenu";
import Banner from './banner';
import TextSlider from './textslide';


class App extends Component {
    constructor(props) {
        super(props)
        this.state = {
            categorylist: [],
            rewardlist: [],
            activePage: 1,
            formData: {},
            errors: {},
            formSubmitted: false,
            loading: false,
            pagecount: 1,
            playerid: null,
            user_id: null,
            point: null,
            products_page_count: 1,
            loginstate: false,
            firstname: null,
            lastname: null,
            alert: null,
            activeProviderIndex: 0,
            activeProvider: null,
            gamelist: [],
        }

        this.handleClick = this.handleClick.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.hideAlert = this.hideAlert.bind(this);
    }

    handlePageChange(pageNumber) {
        this.setState({ activePage: pageNumber });

        instance
            .get("/api/v1/rewardlist", {
                params: {
                    Cat_ID: 0,
                    page: pageNumber
                }
            })
            .then((res) => {
                this.setState({
                    rewardlist: res.data.message.products,
                    pagecount: res.data.message.pagecount,
                    products_page_count: res.data.message.products_page_count
                });
            });
    }

    handleClick = async (e) => {
        this.setState({
            activePage: 1,
            isActive: true,
            activeTab: 0
        });

        instance.get("/api/v1/rewardlist", {
            params: {
                Cat_ID: e.target.id,
                page: 1
            }
        })
            .then((res) => {
                this.setState({
                    rewardlist: res.data.message.products,
                    pagecount: res.data.message.pagecount,
                    products_page_count: res.data.message.products_page_count
                });
            });

        this.setState({
            isActive: false
        });
    }

    hideAlert() {
        this.setState({
            alert: null
        });
    }

    checklogin() {
        var token = localStorage.getItem('auth_token');

        if (token != null) {
            var decoded = jwt_decode(token);

            this.setState({
                user_id: decoded.message.playerid,
                playerid: decoded.message.member_id,
                firstname: decoded.message.firstname,
                lastname: decoded.message.lastname,
                point: decoded.message.Point,
                loginstate: true,
            });
        }
        else {
            this.setState({
                loginstate: false,
            });
        }
    }

    getProviderName = (item) => {
        return (
            item?.providername ||
            item?.ProviderName ||
            item?.name ||
            item?.Name ||
            item?.productname ||
            item?.description ||
            item?.Description ||
            item?.title ||
            "PK8 Sports"
        );
    }

    getProviderCode = (item) => {
        return (
            item?.providercode ||
            item?.provider_code ||
            item?.ProviderCode ||
            item?.code ||
            item?.Code ||
            item?.gamecode ||
            item?.key ||
            ""
        );
    }

    getProviderLogo = (item) => {
        return (
            item?.logo ||
            item?.Logo ||
            item?.icon ||
            item?.imagepath ||
            item?.img_path ||
            item?.image ||
            item?.Image ||
            item?.img ||
            ""
        );
    }

    getProviderMainImage = (item) => {
        return (
            item?.banner ||
            item?.Banner ||
            item?.banner_img ||
            item?.bannerImage ||
            item?.image_banner ||
            item?.picture ||
            item?.Picture ||
            item?.bigimage ||
            item?.bgimage ||
            item?.imagepath ||
            item?.img_path ||
            item?.image ||
            item?.Image ||
            item?.img ||
            ""
        );
    }

    getProviderDesc = (item) => {
        return (
            item?.detail ||
            item?.Detail ||
            item?.desc ||
            item?.description ||
            item?.Description ||
            "PK8 Sports เป็นเกมเดิมพันกีฬาที่พัฒนาและเปิดตัวโดย PK8 ผู้พัฒนาการพนันกีฬาชั้นนำของตลาด PK8 มีพนักงานมืออาชีพมากกว่า 100 คนและผู้เชี่ยวชาญด้านการบริการลูกค้าที่ปฏิบัติหน้าที่ 365 วันต่อปีตลอด 24 ชั่วโมงเพื่อให้ผู้เล่นทั่วโลกมีประสบการณ์การเดิมพันที่ดีที่สุดและประเภทกีฬาและกิจกรรมที่หลากหลายที่สุด"
        );
    }

    selectProvider = async (item, index) => {
        this.setState({
            activeProvider: item,
            activeProviderIndex: index
        });

        // Fetch game list for the selected provider so redeem() uses the right gameId
        const partnerCode = this.getProviderCode(item);
        if (partnerCode) {
            try {
                const gameRes = await instance.post("/api/v1/tabgamelist", {
                    state: "991",
                    System: Systems,
                    partner: partnerCode,
                    game: "sport",
                });
                if (gameRes.data.status === 200) {
                    const games = Array.isArray(gameRes.data.message) ? gameRes.data.message : [];
                    this.setState({ gamelist: games });
                }
            } catch (err) {
                console.log("[SPORT_SELECT_PROVIDER_ERROR]", err);
            }
        }
    }

    getProviderCode = (item) => {
        return (
            item?.partner || item?.Partner ||
            item?.providercode || item?.provider_code || item?.ProviderCode ||
            item?.code || item?.Code || item?.key || ""
        );
    }

    notify = async (mode, msg) => {
        if (mode == "success") {
            await toast.success(msg, { position: "top-right", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "colored" });
        } else if (mode == "warning") {
            await toast.warning(msg, { position: "top-right", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "colored" });
        } else if (mode == "error") {
            await toast.error(msg, { position: "top-right", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "colored" });
        } else if (mode == "info") {
            await toast.info(msg, { position: "top-right", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "colored" });
        }
    };

    // ✅ เปิดเกม sport — อ่าน token โดยตรง ไม่พึ่ง setState async
    redeem = async (e) => {
        if (e) { e.preventDefault(); e.stopPropagation(); }

        const token = localStorage.getItem('auth_token');
        if (!token) {
            this.notify("error", "กรุณาเข้าสู่ระบบก่อนเล่น");
            return;
        }

        let username;
        try {
            const decoded = jwt_decode(token);
            username = decoded.message.playerid || decoded.message.username || decoded.message.Username;
        } catch (err) {
            this.notify("error", "Session หมดอายุ กรุณา login ใหม่");
            return;
        }

        // ใช้ provider ที่ user เลือก (activeProvider) ไม่ใช่แค่ provider แรก
        const currentProvider = this.state.activeProvider
            || (this.state.categorylist.length > 0 ? this.state.categorylist[0] : null);
        const partner = currentProvider ? this.getProviderCode(currentProvider) : "BTI";

        // fetch gamelist ใหม่สำหรับ provider ที่เลือก (ป้องกัน race condition)
        let gameId = partner;
        try {
            const gameRes = await instance.post("/api/v1/tabgamelist", {
                state: "991",
                System: Systems,
                partner: partner,
                game: "sport",
            }, { timeout: 5000 });
            const games = Array.isArray(gameRes.data?.message) ? gameRes.data.message : [];
            const firstGame = games[0];
            if (firstGame) {
                gameId = firstGame.gameid || firstGame.gameId || firstGame.game_id ||
                         firstGame.code || firstGame.Code || partner;
            }
        } catch (err) {
            console.log("[SPORT_REDEEM_GAMELIST_ERROR]", err?.message);
        }

        if (!partner) {
            this.notify("error", "ไม่พบข้อมูล provider กรุณาลองใหม่");
            return;
        }

        try {
            const res = await instance.post("/api/v1/tablauncher", {
                gameId: gameId,
                partner: partner,
                playerUsername: username,
                isMobile: window.innerWidth <= 760,
                System: Systems,
                demo: false
            });

            if (res.data.status === 200) {
                const launcher = res.data.message?.launcher;
                if (launcher) {
                    const isMobile = window.innerWidth <= 760;
                    if (/iPad|iPhone|Macintosh|iPod/.test(navigator.userAgent) && !window.MSStream) {
                        window.location.href = launcher.mobile || launcher.desktop;
                    } else if (!isMobile) {
                        window.open(launcher.desktop || launcher.mobile, "_blank", "height=1000,width=1000");
                    } else {
                        window.open(launcher.mobile || launcher.desktop);
                    }
                } else {
                    this.notify("error", "ขณะนี้เกมมีปัญหา กรุณารอซักครู่");
                }
            } else {
                this.notify("error", res.data.message || "เปิดเกมไม่สำเร็จ");
            }
        } catch (err) {
            console.log("[LAUNCH_SPORT_ERROR]", err);
            this.notify("error", "ขณะนี้เกมมีปัญหา กรุณารอซักครู่");
        }
    };

    async componentDidMount() {
        this.checklogin();

        await instance.post("/api/v1/tabgamelist", {
            state: "5",
            System: Systems,
        })
            .then(async (res) => {
                if (res.data.status === 200) {
                    const categorylist = Array.isArray(res.data.message) ? res.data.message : [];
                    const firstProvider = categorylist.length > 0 ? categorylist[0] : null;
                    const partnerCode = firstProvider
                        ? (firstProvider.partner || firstProvider.Partner ||
                           firstProvider.providercode || firstProvider.ProviderCode ||
                           firstProvider.code || "BTI")
                        : "BTI";

                    this.setState({
                        categorylist,
                        activeProvider: firstProvider,
                        activeProviderIndex: 0,
                    });

                    // ดึง game list ของ provider แรก เพื่อเอา gameid ไปใช้ตอน redeem
                    await instance.post("/api/v1/tabgamelist", {
                        state: "991",
                        System: Systems,
                        partner: partnerCode,
                        game: "sport",
                    }).then((gameRes) => {
                        if (gameRes.data.status === 200) {
                            const games = Array.isArray(gameRes.data.message) ? gameRes.data.message : [];
                            this.setState({ gamelist: games });
                        }
                    }).catch((err) => {
                        console.log("[SPORT_GAMELIST_ERROR]", err);
                    });
                }
            })
            .catch((err) => {
                console.log("[TABGAMELIST_ERROR]", err);
            });
    }

    renderProviderLogo(item) {
        const logo = this.getProviderLogo(item);
        const name = this.getProviderName(item);

        if (logo) {
            return (
                <img
                    src={logo}
                    alt={name}
                    style={{
                        maxWidth: "76px",
                        maxHeight: "38px",
                        objectFit: "contain",
                        display: "block",
                        margin: "0 auto"
                    }}
                />
            );
        }

        return (
            <span>{name}</span>
        );
    }

    render() {
        const { categorylist, activeProvider, activeProviderIndex } = this.state;

        const currentProvider = activeProvider || (categorylist.length > 0 ? categorylist[0] : null);

        const providerName = currentProvider ? this.getProviderName(currentProvider) : "PK8 Sports";
        const providerCode = currentProvider ? this.getProviderCode(currentProvider) : "BTI";
        const providerDesc = currentProvider ? this.getProviderDesc(currentProvider) : "PK8 Sports เป็นเกมเดิมพันกีฬาที่พัฒนาและเปิดตัวโดย PK8 ผู้พัฒนาการพนันกีฬาชั้นนำของตลาด PK8 มีพนักงานมืออาชีพมากกว่า 100 คนและผู้เชี่ยวชาญด้านการบริการลูกค้าที่ปฏิบัติหน้าที่ 365 วันต่อปีตลอด 24 ชั่วโมงเพื่อให้ผู้เล่นทั่วโลกมีประสบการณ์การเดิมพันที่ดีที่สุดและประเภทกีฬาและกิจกรรมที่หลากหลายที่สุด";
        const providerMainImage = currentProvider ? this.getProviderMainImage(currentProvider) : "";

        return (
            <>
                <div className="providerLandingIndexContainer sports-container">
                    <div className="_productBannerContainer_1ma75_1 product-banner-container">
                        <div className="slick-slider slider slick-initialized">
                            <div className="slick-list">
                                <div
                                    className="slick-track"
                                    style={{
                                        width: "100%",
                                        opacity: 1,
                                        transform: "translate3d(0px, 0px, 0px)"
                                    }}
                                >
                                    <div
                                        data-index={0}
                                        className="slick-slide slick-active slick-current"
                                        tabIndex={-1}
                                        aria-hidden="false"
                                        style={{
                                            outline: "none",
                                            width: "100%"
                                        }}
                                    >
                                        <div>
                                            <div
                                                className="_productBannerWrapper_1ma75_1 top top-provider-img"
                                                tabIndex={-1}
                                                style={{
                                                    width: "100%",
                                                    display: "inline-block"
                                                }}
                                            >
                                                <picture>
                                                    <source
                                                        type="image/webp"
                                                        srcSet="https://s3.newworld.center/image/a1eb5ba2-6fcc-4a40-bbf2-cd3a5cffce66.webp"
                                                    />
                                                    <img
                                                        src="https://s3.newworld.center/image/a1eb5ba2-6fcc-4a40-bbf2-cd3a5cffce66.webp"
                                                        className="_productBanner_1ma75_1 provider-banner"
                                                        alt="banner-img"
                                                    />
                                                </picture>

                                                <div className="_content_1ma75_25 top-provider-content ">
                                                    <p className="_title_1ma75_48 provider-type">Sportsbook</p>
                                                    <div className="_desc_1ma75_58 provider-desc" />
                                                </div>

                                                <div className="bk8-logo-container">
                                                    <div className="logo-img" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="mid" id="provider-box">
                        <ul className="provider-box">
                            {categorylist.length > 0 ? (
                                categorylist.map((item, index) => {
                                    const name = this.getProviderName(item);
                                    const code = this.getProviderCode(item);
                                    const isActive = activeProviderIndex === index;

                                    return (
                                        <li
                                            key={`${code || name}-${index}`}
                                            className={`tab-header ${isActive ? "active" : "false"}`}
                                            data-provider-name={name}
                                            data-provider-code={code}
                                            onClick={() => this.selectProvider(item, index)}
                                        >
                                            {index === 0 ? (
                                                <p className="float-dot hot-provider">ฮอต</p>
                                            ) : null}

                                            <div className="tab-inner">
                                                {this.renderProviderLogo(item)}
                                                <span>{name}</span>
                                            </div>
                                        </li>
                                    );
                                })
                            ) : (
                                <li
                                    className="tab-header active"
                                    data-provider-name="BTI"
                                    data-provider-code="BTI"
                                >
                                    <p className="float-dot hot-provider">ฮอต</p>
                                    <div className="tab-inner">
                                        <span>PK8 Sports</span>
                                    </div>
                                </li>
                            )}
                        </ul>
                    </div>

                    <div className="bottom-category">
                        <div className="bottom-content">
                            <div className="title">{providerName}</div>

                            <div className="subtitle">
                                เว็บพนันกีฬาออนไลน์ที่มีชื่อเสียงที่สุดในเอเชีย
                            </div>

                            <div className="description">
                                {providerDesc}
                            </div>

                            <button onClick={(e) => this.redeem(e)}>เล่นตอนนี้</button>
                        </div>

                        <div className="bottom-content-img">
                            {providerMainImage ? (
                                <picture>
                                   <img
                                        src="https://s3.newworld.center/image/4b44829d-738b-4db7-8b97-dc85935f8db4.webp"
                                        alt={providerCode}
                                    />
                                </picture>
                            ) : (
                                <picture>
                                    <source
                                        type="image/webp"
                                        srcSet="/build/web/igame-index-lobby-wm/img/BTI.webp"
                                    />
                                    <img
                                        src="https://s3.newworld.center/image/4b44829d-738b-4db7-8b97-dc85935f8db4.webp"
                                        alt={providerCode}
                                    />
                                </picture>
                            )}
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default App;